import store from '@/store'
import { openDB } from 'idb'

export const CACHE_KEYS = {
  STORE: {
    SERVICE_AREAS: 'serviceAreas',
    PARKING_AREAS: 'parkingAreas',
    SLOW_SPEED_AREAS: 'slowSpeedAreas',
    RESTRICTED_AREAS: 'restrictedAreas',
    RENT_STATION_AREAS: 'rentStationAreas',
    SUNPOD_STATION_AREAS: 'sunpodStationAreas',
    REWARD_ZONES: 'rewardZones',
    PRIORITY_ZONES: 'priorityZones',
    COUNTRIES: 'countries',
    LANGUAGES: 'languages',
    CURRENCIES: 'currencies',
    ORG_CURRENCIES: 'orgCurrencies',
    FLEETS: 'fleets',
    ROLES: 'roles',
    VEHICLE_MANUFACTURES: 'vehicleManufacturers',
    LOCK_IOTS: 'lockIots',
    LOCK_MANUFACTURES: 'lockManufacturers',
    PAYMENT_GATEWAYS: 'paymentGateways',
    ORG_VEHICLE_MODELS: 'orgVehicleModels',
    IOT_TYPE_SETTINGS_CHOICES: 'iotTypeSettingsChoices',
    TAX_PLANS: 'taxPlans',
    TRIP_PACKAGE_CHOICES: 'tripPackageChoices',
    SPEED_LIMIT_CHOICES: 'speedLimitChoices',
    CITY_FEE_CHOICES: 'cityFeeChoices',
    LONG_RENT_PACKAGE_CHOICES: 'longRentPackageChoices',
    RENT_ADDONS_CHOICES: 'rentAddonsChoices',
    RENTAL_FEE_UNIT_CHOICES: 'rentalFeeUnitChoices',
    PERMISSIONS: 'permissions',
    PERMISSION_AVAILABLE_ACTION: 'permissionsAvailableActions',
    VEHICLE_MODEL_MAX_SPEED_UNIT_CHOICES: 'vehicleModeLMaxSpeedUnitChoices',
    VEHICLE_MODEL_RANGE_UNIT_CHOICES: 'vehicleModelRangeUnitChoices',
    VEHICLE_MODEL_BATTERY_CAPACITY_UNIT_CHOICES:
      'vehicleModelBatteryCapacityUnitChoices',
    VEHICLE_MODEL_CHARGING_TIME_UNIT_CHOICES:
      'vehicleModelChargingTimeUnitChoices',
    VEHICLE_MODEL_MOTOR_POWER_RATING_UNIT_CHOICES:
      'vehicleModelMotorPowerRatingUnitChoices',
    VEHICLE_MODEL_NET_WEIGHT_UNIT_CHOICES: 'vehicleModelNetWeightUnitChoices',
    VEHICLE_MODEL_WHEEL_DIAMETER_UNIT_CHOICES:
      'vehicleModelWheelDiameterUnitChoices',
    PARKING_AREA_OPERATION_MODE_CHOICES: 'parkingAreaOperationModeChoices',
    PARKING_AREA_VISIBILITY_MODE_CHOICES: 'parkingAreaVisibilityModeChoices',
    PRIORITY_ZONE_PARKING_MODE_CHOICES: 'priorityZoneParkingModeChoices',
    USER_TYPE_CHOICES: 'userTypeChoices',
    INVOICING_SERVICE_CHOICES: 'invoicingServiceChoices',
    RENT_DURATION_MODE_CHOICES: 'rentDurationModeChoices',
    RENT_VEHICLE_RETURN_AREA_POLICY_CHOICES:
      'rentVehicleReturnAreaPolicyChoices',
    RENT_VEHICLE_ASSIGNMENT_POLICY_CHOICES:
      'rentVehicleAssignmentPolicyChoices',
    VEHICLE_LED_COLOR_CONTROL_TYPE_CHOICES: 'vehicleLedColorControlTypeChoices',
    VEHICLE_LED_COLOR_CHOICES: 'vehicleLedColorChoices',
    CHARGING_PLATFORM_CHOICES: 'chargingPlatformChoices',
    ORG_MESSAGE_TYPE_CHOICES: 'orgMessageTypeChoices',
    VEHICLE_QR_CODE_SCAN_ACTION_CHOICES: 'vehicleQrCodeScanActionChoices',
    CO2_SAVED_UNIT_CHOICES: 'co2SavedUnitChoices',
    WEIGHT_UNIT_CHOICES: 'weightUnitChoices',
    SERVICE_UNAVAILABILITY_TYPE_CHOICES: 'serviceUnavailabilityTypeChoices',
    CRUD_LOGS_LOGGED_MODEL: 'crudLogsLoggedModel',
    ORG_EMAIL_SETTINGS: 'orgEmailSettings',
  },
  TIME: {
    SERVICE_AREAS: 'serviceAreas_lastUpdatedAt',
    PARKING_AREAS: 'parkingAreas_lastUpdatedAt',
    SLOW_SPEED_AREAS: 'slowSpeedAreas_lastUpdatedAt',
    RESTRICTED_AREAS: 'restrictedAreas_lastUpdatedAt',
    RENT_STATION_AREAS: 'rentStationAreas_lastUpdatedAt',
    SUNPOD_STATION_AREAS: 'sunpodStationAreas_lastUpdatedAt',
    REWARD_ZONES: 'rewardZones_lastUpdatedAt',
    PRIORITY_ZONES: 'priorityZones_lastUpdatedAt',
    COUNTRIES: 'countries_lastUpdatedAt',
    LANGUAGES: 'languages_lastUpdatedAt',
    CURRENCIES: 'currencies_lastUpdatedAt',
    ORG_CURRENCIES: 'orgCurrencies_lastUpdatedAt',
    FLEETS: 'fleets_lastUpdatedAt',
    ROLES: 'roles_lastUpdatedAt',
    VEHICLE_MANUFACTURES: 'vehicleManufacturers_lastUpdatedAt',
    LOCK_IOTS: 'lockIots_lastUpdatedAt',
    LOCK_MANUFACTURES: 'lockManufacturers_lastUpdatedAt',
    PAYMENT_GATEWAYS: 'paymentGateways_lastUpdatedAt',
    ORG_VEHICLE_MODELS: 'orgVehicleModels_lastUpdatedAt',
    IOT_TYPE_SETTINGS_CHOICES: 'iotTypeSettingsChoices_lastUpdatedAt',
    TAX_PLANS: 'taxPlans_lastUpdatedAt',
    TRIP_PACKAGE_CHOICES: 'tripPackageChoices_lastUpdatedAt',
    SPEED_LIMIT_CHOICES: 'speedLimitChoices_lastUpdatedAt',
    CITY_FEE_CHOICES: 'cityFeeChoices_lastUpdatedAt',
    LONG_RENT_PACKAGE_CHOICES: 'longRentPackageChoices_lastUpdatedAt',
    RENT_ADDONS_CHOICES: 'rentAddonsChoices_lastUpdatedAt',
    RENTAL_FEE_UNIT_CHOICES: 'rentalFeeUnitChoices_lastUpdatedAt',
    PERMISSIONS: 'permissions_lastUpdatedAt',
    PERMISSION_AVAILABLE_ACTION: 'permissionsAvailableActions_lastUpdatedAt',
    VEHICLE_MODEL_MAX_SPEED_UNIT_CHOICES:
      'vehicleModeLMaxSpeedUnitChoices_lastUpdatedAt',
    VEHICLE_MODEL_RANGE_UNIT_CHOICES:
      'vehicleModelRangeUnitChoices_lastUpdatedAt',
    VEHICLE_MODEL_BATTERY_CAPACITY_UNIT_CHOICES:
      'vehicleModelBatteryCapacityUnitChoices_lastUpdatedAt',
    VEHICLE_MODEL_CHARGING_TIME_UNIT_CHOICES:
      'vehicleModelChargingTimeUnitChoices_lastUpdatedAt',
    VEHICLE_MODEL_MOTOR_POWER_RATING_UNIT_CHOICES:
      'vehicleModelMotorPowerRatingUnitChoices_lastUpdatedAt',
    VEHICLE_MODEL_NET_WEIGHT_UNIT_CHOICES:
      'vehicleModelNetWeightUnitChoices_lastUpdatedAt',
    VEHICLE_MODEL_WHEEL_DIAMETER_UNIT_CHOICES:
      'vehicleModelWheelDiameterUnitChoices_lastUpdatedAt',
    PARKING_AREA_OPERATION_MODE_CHOICES:
      'parkingAreaOperationModeChoices_lastUpdatedAt',
    PARKING_AREA_VISIBILITY_MODE_CHOICES:
      'parkingAreaVisibilityModeChoices_lastUpdatedAt',
    PRIORITY_ZONE_PARKING_MODE_CHOICES:
      'priorityZoneParkingModeChoices_lastUpdatedAt',
    USER_TYPE_CHOICES: 'userTypeChoices_lastUpdatedAt',
    INVOICING_SERVICE_CHOICES: 'invoicingServiceChoices_lastUpdatedAt',
    RENT_DURATION_MODE_CHOICES: 'rentDurationModeChoices_lastUpdatedAt',
    RENT_VEHICLE_RETURN_AREA_POLICY_CHOICES:
      'rentVehicleReturnAreaPolicyChoices_lastUpdatedAt',
    RENT_VEHICLE_ASSIGNMENT_POLICY_CHOICES:
      'rentVehicleAssignmentPolicyChoices_lastUpdatedAt',
    VEHICLE_LED_COLOR_CONTROL_TYPE_CHOICES:
      'vehicleLedColorControlTypeChoices_lastUpdatedAt',
    VEHICLE_LED_COLOR_CHOICES: 'vehicleLedColorChoices_lastUpdatedAt',
    CHARGING_PLATFORM_CHOICES: 'chargingPlatformChoices_lastUpdatedAt',
    ORG_MESSAGE_TYPE_CHOICES: 'orgMessageTypeChoices_lastUpdatedAt',
    VEHICLE_QR_CODE_SCAN_ACTION_CHOICES:
      'vehicleQrCodeScanActionChoices_lastUpdatedAt',
    CO2_SAVED_UNIT_CHOICES: 'co2SavedUnitChoices_lastUpdatedAt',
    WEIGHT_UNIT_CHOICES: 'weightUnitChoices_lastUpdatedAt',
    SERVICE_UNAVAILABILITY_TYPE_CHOICES:
      'serviceUnavailabilityTypeChoices_lastUpdatedAt',
    CRUD_LOGS_LOGGED_MODEL: 'crudLogsLoggedModel_lastUpdatedAt',
    ORG_EMAIL_SETTINGS: 'orgEmailSettings_lastUpdatedAt',
  },
  EXPIRE_TIME: {
    THREE_DAYS: 259200000,
  },
}

export const CACHE_INDEXES = {
  [CACHE_KEYS.STORE.PARKING_AREAS]: ['is_active'],
  [CACHE_KEYS.STORE.SERVICE_AREAS]: ['is_active'],
  [CACHE_KEYS.STORE.SLOW_SPEED_AREAS]: ['is_active'],
  [CACHE_KEYS.STORE.RESTRICTED_AREAS]: ['is_active'],
  [CACHE_KEYS.STORE.RENT_STATION_AREAS]: ['is_active'],
  [CACHE_KEYS.STORE.SUNPOD_STATION_AREAS]: ['is_active'],
  [CACHE_KEYS.STORE.REWARD_ZONES]: ['is_active'],
  [CACHE_KEYS.STORE.PRIORITY_ZONES]: ['is_active'],
}

const DB_NAME = 'OTO_CacheDB'
const DB_VERSION = 1

// --- Utility: check if IndexedDB is usable (handles Safari Private mode) ---
function hasWorkingIndexedDB() {
  try {
    if (!('indexedDB' in window)) return false
    // Some browsers (Safari private) throw on opening - detect by trying to open and close quickly
    const req = indexedDB.open('__test__')
    req.onerror = () => {}
    req.onsuccess = () => {
      try {
        req.result.close()
        indexedDB.deleteDatabase('__test__')
      } catch (e) {
        // ignore
      }
    }
    return true
  } catch (e) {
    return false
  }
}

// Conservative Safari detection (desktop + iOS).
// returns true for Safari browsers (including iOS Safari), false otherwise.
export function isSafariOrIOS() {
  const ua = navigator.userAgent || ''

  const isSafari =
    /Safari/.test(ua) &&
    !/Chrome|Chromium|CrMo|CriOS|FxiOS|Edg|OPR|Android/.test(ua)

  const isIOSDevice = /iPhone|iPad|iPod/i.test(ua)

  return isSafari || isIOSDevice || true
}

// --- Safe DB opener: only attempt when IndexedDB seems available and not Safari-proof issue ---
export async function getDB() {
  if (!hasWorkingIndexedDB()) {
    // Throw so callers can handle gracefully (we prefer returning empty arrays elsewhere)
    throw new Error('IndexedDB not available')
  }

  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      const stores = Object.values(CACHE_KEYS.STORE)

      stores.forEach((storeName) => {
        let store

        if (!db.objectStoreNames.contains(storeName)) {
          store = db.createObjectStore(storeName, { keyPath: 'id' })
        } else {
          // If it exists, we don't open a transaction here; openDB handles upgrades
          store = null
        }

        const indexKeys = CACHE_INDEXES[storeName] || []
        if (store) {
          indexKeys.forEach((indexKey) => {
            if (!store.indexNames.contains(indexKey)) {
              store.createIndex(indexKey, indexKey)
            }
          })
        }
      })
    },
  })
}

export async function getFromCache(storeName) {
  // Bypass entirely for Safari: caller should fetch API
  if (isSafariOrIOS()) return []

  try {
    const db = await getDB()
    return await db.getAll(storeName)
  } catch (e) {
    // DB broken/unavailable: do a safe reset and logout as before
    console.warn('getFromCache: IndexedDB unavailable or failed', e)
    try {
      await resetDB()
    } catch (_) {
      console.log('failed to reset DB')
    }
    setTimeout(() => {
      store.dispatch('auth/logout').then(() => {
        location.reload()
      })
    }, 2000)
    return []
  }
}

export async function saveToCache(storeName, data) {
  // Do not save for Safari
  if (isSafariOrIOS()) return

  try {
    const db = await getDB()
    const tx = db.transaction(storeName, 'readwrite')
    const storeObj = tx.objectStore(storeName)

    data.forEach((item) => storeObj.put(item))
    await tx.done
  } catch (e) {
    console.warn('saveToCache: failed', e)
    try {
      await resetDB()
    } catch (_) {
      console.log('failed to reset DB')
    }
    setTimeout(() => {
      store.dispatch('auth/logout').then(() => {
        location.reload()
      })
    }, 2000)
  }
}

export function isCacheExpired(key, ttl = CACHE_KEYS.EXPIRE_TIME.THREE_DAYS) {
  // 72hrs default TTL (mili-seconds)
  const last = localStorage.getItem(key)
  return !last || Date.now() - parseInt(last, 10) > ttl
}

export function updateCacheTime(key) {
  localStorage.setItem(key, Date.now())
}

export async function clearCacheAndTime(storeName, cacheTimeKey) {
  // If Safari: no DB to clear; just remove the timestamp
  if (isSafariOrIOS()) {
    localStorage.removeItem(cacheTimeKey)
    return
  }

  try {
    const db = await getDB()
    const tx = db.transaction(storeName, 'readwrite')
    const store = tx.objectStore(storeName)
    await store.clear()
    await tx.done
    localStorage.removeItem(cacheTimeKey)
  } catch (e) {
    console.warn('clearCacheAndTime: failed', e)
    localStorage.removeItem(cacheTimeKey)
  }
}

export async function clearAllCaches() {
  if (isSafariOrIOS()) {
    await clearAllCacheTimes()
    return
  }

  try {
    const db = await getDB()
    const tx = db.transaction(Object.values(CACHE_KEYS.STORE), 'readwrite')
    const stores = Object.values(CACHE_KEYS.STORE)
    stores.forEach((storeName) => {
      const store = tx.objectStore(storeName)
      store.clear()
    })
    await tx.done
  } catch (e) {
    console.error('clearAllCaches failed', e)
  }
}

export async function clearAllCacheTimes() {
  const cacheTimeKeys = Object.values(CACHE_KEYS.TIME)
  cacheTimeKeys.forEach((key) => {
    localStorage.removeItem(key)
  })
}

export async function clearAllCachesAndTimes() {
  try {
    await clearAllCaches()
    await clearAllCacheTimes()
    if (!isSafariOrIOS() && hasWorkingIndexedDB()) {
      indexedDB.deleteDatabase(DB_NAME)
    }
  } catch (e) {
    await clearAllCacheTimes()
    console.error('Error clearing caches and times', { e })
  }
}

export async function resetDB(name = DB_NAME) {
  try {
    const connection = await openDB(name)
    connection.close()
  } catch (e) {
    console.warn('⚠️ Could not close connection to database', { e })
  }

  return new Promise((resolve, reject) => {
    try {
      const request = indexedDB.deleteDatabase(name)
      request.onsuccess = () => {
        console.log(`IndexDB: Database "${name}" deleted successfully`)
        resolve(true)
      }
      request.onerror = (e) => {
        console.error('IndexDB: Failed to delete database', { e })
        reject(e)
      }
      request.onblocked = () => {
        console.warn(
          'IndexDB: Delete blocked — another connection is still open.'
        )
      }
    } catch (e) {
      console.error('resetDB: deleteDatabase threw', e)
      reject(e)
    }
  })
}
